module.exports = __webpack_public_path__ + "1081abfcdda8d80203e0d5e25e31bcca.svg";